import * as types from './action-types';
import { AuthProxy } from '../../../proxies';
import cookie from 'js-cookie';

const getAccount = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().getAccount().then(response => {
      dispatch({ type: types.SET_AUTH_DATA, payload: { data: response, key: 'account' } });
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};


const patch = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().patch(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const check = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().check(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const login = (payload) => {
  payload.grant_type = "password";
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().login(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const loginExternal = (payload) => {
  payload.grant_type = "external_token";
  payload.external_token = cookie.get("araciste.integration.user.token")
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().login(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const loginProxyUser = (payload) => {
  payload.grant_type = "proxy_grant_type";
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().login(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};



const register = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().register().then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const confirmEmail = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().confirmEmail(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const confirm = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().confirm(payload).then(response => {
      dispatch({ type: types.SET_AUTH_DATA, payload: { data: response } });
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const resetPassword = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().resetPassword(payload).then(response => {
      dispatch({ type: types.SET_AUTH_DATA, payload: { data: response } });
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const changePassword = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().changePassword(payload).then(response => {
      // dispatch({ type: types.SET_AUTH_DATA, payload: { data: response } });
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const forgotPasswordConfirm = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().forgotPasswordConfirm(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const forgotPassword = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    return new AuthProxy().forgotPassword(payload).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const logout = (isRefresh) => {
  return dispatch => new Promise((resolve, reject) => {
    // cookie.remove('access_token');
    // cookie.remove('refresh_token');
    // cookie.remove('access_token_expire');
    // cookie.remove('access_token_time');
    cookie.remove('access_token', { domain: process.env.REACT_APP_COOKIE_DOMAIN });
    cookie.remove('refresh_token', { domain: process.env.REACT_APP_COOKIE_DOMAIN });
    cookie.remove('access_token_expire', { domain: process.env.REACT_APP_COOKIE_DOMAIN });

    if (isRefresh) {
      window.location.reload();
    } else {
      window.location.replace('/auth');
    }

  });
};

const changeLanguage = () => {
  return dispatch => new Promise((resolve, reject) => {
    var currentLanguage = localStorage.getItem("i18nextLng").substr(0, 2);
    currentLanguage = currentLanguage === 'tr' ? 'en' : 'tr';
    localStorage.setItem('i18nextLng', currentLanguage);
    window.location.reload();
    // i18n.changeLanguage(currentLanguage, () => dispatch({ type: types.CHANGE_LANGUAGE }))
  });
}


const deletePicture = () => {
  return dispatch =>
    new Promise((resolve, reject) => {
      return new AuthProxy()
        .deletePicture()
        .then(response => {
          dispatch({ type: types.DELETE_PICTURE });
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
};

export default {
  getAccount,
  check,
  logout,
  login,
  loginProxyUser,
  loginExternal,
  register,
  forgotPassword,
  changeLanguage,
  confirm,
  changePassword,
  resetPassword,
  forgotPasswordConfirm,
  confirmEmail,
  patch,
  deletePicture
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js